import {Step} from "./AbstractMulti";
import {AbstractMultiActivate} from "./abstract-multi-activate";

export {template} from "./abstract-multi-activate"

export class viewModel extends AbstractMultiActivate {
    protected active: boolean = false

    protected override onStepChange(step: Step) {
        switch (step) {
            case Step.Introduction:
                this.introMessage = `message: you are about to deactivate subject|s:((${this.getNumObjectsText(this.selectedObjects)}))`;
                break
        }
        super.onStepChange(step);
    }
}
